import { LabelDisplayedRowsArgs } from "@mui/material/TablePagination";
import {
  gridPageSizeSelector,
  GridPagination,
  useGridApiContext,
  useGridSelector
} from "@mui/x-data-grid-pro";
import { ComponentProps } from "react";

import { ROWS_PER_PAGE } from "consts";

type PaginationProps = Omit<ComponentProps<typeof GridPagination>, "labelDisplayedRows">;
export const Pagination = (props: PaginationProps) => {
  const apiRef = useGridApiContext();

  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);

  const displayedRowsToDisplayedPage = ({ from, count }: LabelDisplayedRowsArgs) => {
    const perPage = pageSize ?? ROWS_PER_PAGE;

    const pages = Math.ceil(count / perPage);
    const currentPage = Math.ceil(from / perPage);

    return `Page ${currentPage} of ${pages}`;
  };

  return <GridPagination {...props} labelDisplayedRows={displayedRowsToDisplayedPage} />;
};
